import { render, staticRenderFns } from "./StudentEvaluationHistoryForm.vue?vue&type=template&id=55d01b26"
import script from "./StudentEvaluationHistoryForm.vue?vue&type=script&lang=js"
export * from "./StudentEvaluationHistoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports